import { ManagePointOfContactSpecialistRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateManagePointOfContactSpecialist = (teamSpecialistKeys: string[]) =>
  makeValidator({
    FieldParser: ManagePointOfContactSpecialistRow(teamSpecialistKeys),
  });
